import { AddressLinesItem } from '../../NetSuiteVendorCreationPopupContent.types';

export const defaultAddressLine: AddressLinesItem = {
    label: '',
    defaultBilling: true,
    defaultShipping: true,
    primaryAddress: '',
    secondaryAddress: '',
    addressee: '',
    attention: '',
    city: '',
    countryId: null,
    zip: '',
    state: '',
    phone: '',
};
